import { Sucursal } from "./Sucursal";
import { Rol } from "./rol";

export class SucursalRol {
    sucursal: Sucursal;
    rol: Rol[];
}


// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/sucursalRol.ts